import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=00d6e0cb&scoped=true&"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=00d6e0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d6e0cb",
  null
  
)

export default component.exports